import { isRequiredCurrency } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (values.weekList && values.weekList.length) {
    const week = values.weekList;
    const weekErrors = [];

    week.forEach((weekItem, weekIndex) => {
      if (isRequiredCurrency(weekItem)) {
        weekErrors[weekIndex] = {
          USD: 'Error',
          EUR: 'Error',
          NOK: 'Error'
        };
      }
    });

    const hasErrors = weekErrors.filter(error => error !== undefined).length > 0;

    if (hasErrors) {
      errors.weekList = { 
        ...weekErrors,
        _error: weekErrors.map((error, index) => 
          error = 'Value for at least one currency should be filled in' 
        ).filter(Boolean) 
      };
    }
  }

  return errors;
};

export default validate;